<template>
    <div :class="inputClass">
        <div v-for="(option, index) in options" :key="index" class="form-input-toggle__option">
            <common-info-tip v-if="option.infoTip" class="form-input-toggle__option-info-tip" size="small">
                {{ option.infoTip }}
            </common-info-tip>
            <input
                :id="optionId(option)"
                :checked="isOptionChecked(option)"
                :data-checked="isOptionChecked(option)"
                :name="_uid"
                :value="option.value"
                :autofocus="hasAutofocus"
                :required="isRequired"
                type="radio"
                :disabled="isDisabled"
                @click="change(option.value)"
            />

            <label :for="optionId(option)">
                <common-icon :name="radioIcon(option)" size="medium"></common-icon>

                <span>{{ option.label }}</span>
            </label>

            <div class="form-input-toggle__end">
                <slot :name="optionSlotName(option)"></slot>
            </div>
        </div>
    </div>
</template>

<script>
    import FormInputMixin from 'mixins/FormInputMixin'

    export default {
        mixins: [FormInputMixin],

        props: {
            value: { type: [String, Number, Boolean, Object], default: undefined },
            options: { type: Array, required: true },
            direction: { type: String, default: null },
            checkedIcon: { type: String, default: null },
            color: { type: String, default: 'primary' },
        },

        computed: {
            inputClass() {
                return {
                    'form-input-toggle': true,
                    [`form-input-toggle--direction-${this.direction || 'row'}`]: true,
                    'form-input-toggle--is-disabled': this.isDisabled,
                    [`form-input-toggle__option--${this.color}`]: true,
                }
            },
        },

        methods: {
            isOptionChecked({ value }) {
                if ([null, undefined].includes(this.value)) {
                    return false
                }

                return JSON.stringify(this.value) === JSON.stringify(value)
            },

            radioIcon(option) {
                return this.isOptionChecked(option) ? this.checkedIcon || 'radio-on' : 'radio-off'
            },

            optionId(option) {
                return [this._uid, JSON.stringify(option.value)].join('-')
            },

            optionSlotName({ value }) {
                return `option-${value}`
            },
        },
    }
</script>
